// extracted by mini-css-extract-plugin
export default {"container":"styles_container__4RWWa","container__rigth":"styles_container__rigth__-2PnH"};